import Header from './Components/Pages/Header';

function App() {
  return (
    <>
      <Header data-testid="app"/>
    </>
  );
}

export default App;
